import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "M7.746 18.671a1 1 0 0 0 0 1.44l.228.22a1 1 0 0 0 1.389 0l7.89-7.611a1 1 0 0 0 0-1.44l-7.89-7.61a1 1 0 0 0-1.389 0l-.228.22a1 1 0 0 0 0 1.439L14.663 12z"
    }, null, -1)
  ]))]))
}
export default { render: render }